/*eslint-disable*/
import {commonApi, common} from '@/common/index'
import {mapState} from 'vuex'

const slotMixin = {
  data() {
    return {
      // 游戏图片链接
      picLink: '',
      gameType: 1,
      platformParams: {
        // 游戏平台参数
        // 游戏类型gameType:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
        gameType: 1,
        pageNo: 1,
        pageSize: 50
      },
      // 游戏平台列表
      gameForm: [],
      // 游戏平台图片
      picInfoList: [],
      // 游戏列表(已拼接图片)
      gamePlatformList: []
    }
  },
  computed: {
    ...mapState({
      frontType: state => state.frontType
    })
  },
  mounted() {
    // 老虎机图片ftp地址
    commonApi.HOMEBEFORE.serverInfo()
      .then((picLink) => {
        this.picLink = picLink;
        let platformPicInfoParams = {
          // 平台logo
          frontType: this.frontType,
          gameType: this.gameType
        }
        // 老虎机平台图片
        return commonApi.HOMEBEFORE.platformPicInfo(platformPicInfoParams)
      })
      .then((data) => {
        this.picInfoList = data;
        // 老虎机平台
        return commonApi.HOMEBEFORE.gamePlatform(this.platformParams)
      })
      .then(data=>{
        let platFormList = data.list;
        this.gamePlatformList = common.platformPicjoint(this.picInfoList, platFormList)
      })
      .catch((err) => {

      })
  }
}

export default slotMixin



// WEBPACK FOOTER //
// ./src/common/mixins/game/slotMixin.js